import moment from 'moment';
import timeFormAPI from '../api/ui/timeFormAPI';
import { JUST_NOW_DATE_TIMES } from './base';
import "../api/ui/icons"
import {
  getGrayStateIcon,
  getGreenStateIcon,
  getOrangeStateIcon,
  getRedStateIcon,
  getYellowStateIcon
} from "../api/ui/icons";

export const InitialEventState = {
  DepositWaiting: '입금 대기',
  Waiting: '시작 전',
  Pause: '일시 정지',
  InProgress: '활성',
  CancelEvent: '취소',
  DeleteEvent: '삭제',
  BudgetExhausted: '예산 소진으로 종료',
  Finished: '종료',
};

// /**
//  * 이벤트 상태 반환
//  * @param {string} startAt 시작일시
//  * @param {string} endAt 종료일시
//  * @param {null} depositState 입금 상태가 있는 경우 인자값 전달하여 사용 없으면 null
//  * */
// export const getEventStatus = (startAt, endAt, depositState = null) => {
//   if (depositState !== 1) {
//     if (depositState === 0) {
//       return InitialEventState.DepositWaiting
//     }
//
//     if (depositState === 2) {
//       return InitialEventState.BudgetExhausted
//     }
//
//     return InitialEventState.CancelEvent
//   }
//
//   const now = moment.utc().unix();
//   // CampaignListData.startAt과 endAt에서 서버에서 받은 날짜 문자열이 Date 타입으로 바뀔 때 로컬 시간으로 변경된다.
//   // 이 문제로 인해 moment(startAt).format('YYYY-MM-DDTHH:mm:00')라는 단계를 거친다.
//   // 서버에서 UTC 형태로 와야 한다.
//   const start = moment
//     .utc(moment(startAt).format('YYYY-MM-DDTHH:mm:00'))
//     .unix();
//   const end = moment.utc(moment(endAt).format('YYYY-MM-DDTHH:mm:00')).unix();
//
//   if (now < start) {
//     return InitialEventState.Waiting
//   }
//
//   if (now <= end) {
//     return InitialEventState.InProgress
//   }
//
//   return InitialEventState.Finished
// };

// export const getEventStatusIcons = (startAt, endAt, depositState = null) => {
//   if (depositState !== 1) {
//     if (depositState === 0) {
//       return (
//         <>
//           <img src={notStartIcon} /> {InitialEventState.DepositWaiting}
//         </>
//       );
//     }
//
//     if (depositState === 2) {
//       return (
//         <>
//           <img src={endedIcon} /> {InitialEventState.BudgetExhausted}
//         </>
//       );
//     }
//
//     return (
//       <>
//         <img src={notStartIcon} /> {InitialEventState.CancelEvent}
//       </>
//     );
//   }
//
//   const now = moment.utc().unix();
//   // CampaignListData.startAt과 endAt에서 서버에서 받은 날짜 문자열이 Date 타입으로 바뀔 때 로컬 시간으로 변경된다.
//   // 이 문제로 인해 moment(startAt).format('YYYY-MM-DDTHH:mm:00')라는 단계를 거친다.
//   // 서버에서 UTC 형태로 와야 한다.
//   const start = moment
//     .utc(moment(startAt).format('YYYY-MM-DDTHH:mm:00'))
//     .unix();
//   const end = moment.utc(moment(endAt).format('YYYY-MM-DDTHH:mm:00')).unix();
//
//   if (now < start) {
//     return (
//       <>
//         <img src={notStartIcon} /> {InitialEventState.Waiting}
//       </>
//     );
//   }
//
//   if (now <= end) {
//     return (
//       <>
//         <img src={activeIcon} /> {InitialEventState.InProgress}
//       </>
//     );
//   }
//
//   return (
//     <>
//       <img src={endedIcon} /> {InitialEventState.Finished}
//     </>
//   );
// };

// TODO 상태 체크하는 부분 이 함수로 대치 예정(Visible 태그에서 InitialEventState와 비교시 includes(InitialEventState.???)을 사용
// 해당 데이터에 depositTransactionStatus, enabled 없는 경우는 기본값으로 날짜만 입력하여 사용
/**
 * 이벤트 상태 String 반환
 * @param startAt
 * @param endAt
 * @param {number} depositTransactionStatus
 * @param {boolean} enabled
 * @returns {string}
 * @constructor
 */
export const getEventState = ({
  startAt,
  endAt,
  depositTransactionStatus = 1,
  enabled = true,
}) => {
  const beginAt = moment(timeFormAPI.changeDataLog(startAt)).format(
    'YYYY-MM-DDTHH:mm:ss',
  );
  const endingAt = moment(timeFormAPI.changeDataLog(endAt)).format(
    'YYYY-MM-DDTHH:mm:ss',
  );
  const now = JUST_NOW_DATE_TIMES.value;

  // enabled, depositTransactionStatus 상관 없이 이미 종료 기간이 지났으면 [완료]로 표시
  if (moment(endingAt).isSameOrBefore(now)) {
    return InitialEventState.Finished;
  }

  if (!enabled) {
    return InitialEventState.Pause;
  }

  if (depositTransactionStatus !== 1) {
    switch (depositTransactionStatus) {
      case 0:
        return InitialEventState.DepositWaiting;
      case 2:
        return InitialEventState.BudgetExhausted;
      case 3:
        return InitialEventState.CancelEvent;
    }
  }

  if (moment(beginAt).isAfter(now)) {
    return InitialEventState.Waiting;
  }

  if (moment(beginAt).isSameOrBefore(now) && moment(endingAt).isAfter(now)) {
    return InitialEventState.InProgress;
  }

  return '';
};

/**
 *
 * 이벤트 상태 아이콘 + String 반환
 * @param startAt
 * @param endAt
 * @param {number} depositTransactionStatus
 * @param {boolean} enabled
 * @returns {React.JSX.Element|string}
 * @constructor
 */
export const getEventStateIcon = ({
  startAt,
  endAt,
  depositTransactionStatus,
  enabled,
}) => {
  const state = getEventState({
    startAt,
    endAt,
    depositTransactionStatus,
    enabled,
  });

  switch (state) {
    case InitialEventState.Waiting:
    case InitialEventState.CancelEvent:
      return getGrayStateIcon(state);

    case InitialEventState.DepositWaiting:
    case InitialEventState.Pause:
      return getYellowStateIcon(state);

    case InitialEventState.InProgress:
      return getOrangeStateIcon(state);

    case InitialEventState.Finished:
    case InitialEventState.BudgetExhausted:
      return getGreenStateIcon(state);

    case InitialEventState.DeleteEvent:
      return getRedStateIcon(state);

    default:
      return '';
  }
};

